import { render } from "./CreateRoute.vue?vue&type=template&id=1d0b859f&scoped=true"
import script from "./CreateRoute.vue?vue&type=script&lang=ts"
export * from "./CreateRoute.vue?vue&type=script&lang=ts"

import "./CreateRoute.vue?vue&type=style&index=0&id=1d0b859f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d0b859f"

export default script